import {
  SemanticsList,
  ThemeTokensSemantic,
  useThemeTokensSemantic,
} from "shared/theme/sidespor/theme/themeSemantics";
import { SystemStyleObject } from "shared/theme/sidespor/types";

/**
 * Example:
 *
 * --- Input looks like this ---
 * (theme) =>
 * ({
 *  backgroundColor: theme.colorSemanticFill,
 *  color: theme.colorSemanticTextMain,
 * })
 * ---------------------------------
 *
 * --- Output looks like this ---
 * {
 *  alarm: {
 *    backgroundColor: "semantics.colorAlarmFill"
 *    color: "semantics.colorAlarmTextMain"
 *  }
 *  info: {
 *    backgroundColor: "semantics.colorInfoFill"
 *    color: "semantics.colorInfoTextMain"
 *  }
 *  ...
 * }
 * ---------------------------------
 *
 * Docs: https://chakra-ui.com/docs/theming/semantic-tokens#using-in-recipes
 */
export const defineSemantics = (
  definitionFunc: (theme: ThemeTokensSemantic) => SystemStyleObject,
) =>
  Object.fromEntries(
    SemanticsList.map((semantic) => {
      const themeSemantic = useThemeTokensSemantic(semantic);
      return [semantic, definitionFunc(themeSemantic)];
    }),
  );
